<template>
<v-row justify="center">
<v-dialog v-model="dialog_local" max-width="650">
    <v-form ref="ct" action="#" @submit.prevent="beforeCreateForm('create')" lazy-validation>
        <v-card class="mx-auto" tile>
        <v-card-title class="justify-space-between" style="background-color: #3D348B; color: white; padding-top: 5px; padding-bottom: 5px">
            Add Car Park Bays
            <v-btn text @click="$emit('closed', false)" fab depressed small><v-icon small color="white">fas fa-times</v-icon></v-btn>
            </v-card-title>
        <v-card-text>
        <v-container class="fill-height"
        fluid >
            <v-row>
                <v-col cols="4">
                    <v-btn-toggle>
                    <v-btn class="white--text" color="primary" small @click.prevent="addRow('add')">+</v-btn>
                    <v-text-field
                        dense
                        v-model="total"
                        outlined
                        type="text"
                        disabled
                    ></v-text-field>
                    <v-btn class="white--text" color="error" small @click.prevent="addRow('remove')">-</v-btn>
                    </v-btn-toggle>
                </v-col>
                <v-col cols="4">
                    <v-checkbox
                    v-model="selectIteratingName"
                    label="Iterate Bay Name ID"
                    ></v-checkbox>
                </v-col>
            </v-row>
            <v-row v-for="(item, index) in form" :key="index">
                <v-col cols="12" md="3">
                    <v-text-field
                        dense
                        outlined
                        type="text"
                        v-model="item[1].baynameid"
                        :rules="item[1].rule"
                        label="Bay Name ID"
                        required
                        hide-details="auto"
                        autocomplete="off"
                    ></v-text-field>
                </v-col>
                <v-col cols="12" md="3">
                    <v-text-field
                        dense
                        outlined
                        type="text"
                        v-model="item[2].baytype"
                        :rules="item[2].rule"
                        label="Bay Type"
                        required
                        hide-details="auto"
                        autocomplete="off"
                    ></v-text-field>
                </v-col>
                <v-col cols="12" md="3">
                    <v-text-field
                        dense
                        outlined
                        type="text"
                        v-model="item[3].baylatitude"
                        :rules="item[3].rule"
                        label="Bay Latitude"
                        required
                        hide-details="auto"
                        autocomplete="off"
                    ></v-text-field>
                </v-col>
                <v-col cols="12" md="3">
                    <v-text-field
                        dense
                        outlined
                        type="text"
                        v-model="item[4].baylongitude"
                        :rules="item[4].rule"
                        label="Bay Longitude"
                        required
                        hide-details="auto"
                        autocomplete="off"
                    ></v-text-field>
                </v-col>
            </v-row>
        </v-container>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
            <v-btn tile type="submit" small color="primary"><v-icon left x-small dark>fa fa-save</v-icon>Save</v-btn>
            <v-btn tile color="blue darken-1" text @click="$emit('closed', false)">Close</v-btn>
        </v-card-actions>
        </v-card>
    </v-form>
    <alertbox :dialog="innerModal" :customText="ma.customText" :modal_action_type="ma.modal_action_type" :modalInfo="ma.modalInfo" @confirm="onConfirm" @closed="onClosed"></alertbox>
</v-dialog>
</v-row>
</template>
<script>
import alertbox from './Alert';
import _ from 'lodash';

export default {
    props: ['dialog', 'modalInfo', 'customText', 'system', 'master', 'allInfo'],
    
    data()  {
        return {
            dialog_local: false,
            innerModal: false,
            form: [ 
                [
                {carparkid: '', rule: [] },
                {baynameid: '', rule: [] },
                {baytype: '', rule: [] },
                {baylatitude: '', rule: [] },
                {baylongitude: '', rule: [] },
                {bayid: '' },
                ]
            ],

            roles: [],
            ma: {
                modal: false,
                modal_action_type: '',
                modalInfo: [],
                customText: [],
                edit_modal: false,
                view_modal: false,
                confirmEdit: false,
                confirmCreate: false,
            },
            total: 1,
            extractedNumFromString: 1,
            selectIteratingName: false
        }
    },

    components: {alertbox},

    watch: {
        dialog: {
        handler: async function(value) {
            this.modalHandler();
            if(value == true){
                this.handleValue();
            }
        },
        },

        dialog_local: {
        handler: function(value) {
            this.modalCloseHandler();
        },
        },
    },

    created(){
        //this.$watch(() => this.form[0].systemid, this.onRuleChange);
        //this.$watch(() => this.form[1].systemname, this.onRuleChange);
    },

    methods: {
        async checkRef(val){
            if (val != undefined){
                let system = await this.allInfo;
                let check = system.some((item) => {
                    return item.SystemID.toLowerCase() == val.toLowerCase();
                });

                return check;
            }

            else{
                return '';
            }
        },

        addRow(typ){
            //let stringHasNum = /\d/.test(this.form[0][1].baynameid);
            //if (stringHasNum){
            let extractedStringFromNum = this.form[0][1].baynameid.replace(/[0-9]/g,'');
            let rq;
            //}

            if (typ == 'add'){
                this.extractedNumFromString = this.form.length + 1;
                if (this.selectIteratingName){
                    rq = [{carparkid: '', rule: [] },
                    {baynameid: `${extractedStringFromNum + this.extractedNumFromString}`, rule: [] },
                    {baytype: '', rule: [] },
                    {baylatitude: '', rule: [] },
                    {baylongitude: '', rule: [] },
                    {bayid: '' }
                    ];
                }

                else{
                    rq = [{carparkid: '', rule: [] },
                    {baynameid: '', rule: [] },
                    {baytype: '', rule: [] },
                    {baylatitude: '', rule: [] },
                    {baylongitude: '', rule: [] },
                    {bayid: '' }
                    ];
                }

                this.form.push(rq);
                this.total = this.form.length;
            }

            if (typ == 'remove'){
                if (this.modalInfo.Bays.length == 0 && this.form.length > 1){
                    this.form.pop();
                    this.total = this.form.length;
                    this.extractedNumFromString = this.extractedNumFromString - 1;
                }

                if (this.modalInfo.Bays.length > 0 && this.form.length > this.modalInfo.Bays.length){
                    this.form.pop();
                    this.total = this.form.length;
                    this.extractedNumFromString = this.extractedNumFromString - 1;
                }
            }

            /*
            if (typ == 'textbox'){
                let rows = this.total - this.form.length;
                for (let i=0; i<rows; i++){
                    this.form.push(rq);
                }
            }
            */
        },

        onRuleChange(after, before) {
            //this.form[0].rule = [];
            //this.form[1].rule = [];
        },

        async beforeCreateForm(flag){
            for (var i=0; i<this.form.length; i++){
                this.form[i][1].rule = [
                    v => !!v || 'Bay Name is required',
                ];

                this.form[i][2].rule = [
                    v => !!v || 'Bay Type is required',
                ];

                this.form[i][3].rule = [
                    v => !v || !isNaN(v) || 'Only number is allowed'
                ];

                this.form[i][4].rule = [
                    v => !v || !isNaN(v) || 'Only number is allowed'
                ];
            }

            //must set this in order to use 'this' as 'self' inside settimeout etc..
            let self = this;

            setTimeout(function () {
             if (self.$refs.ct.validate()) {
                    self.innerModal = true;
                    self.ma.modalInfo = {id: 1, name: 2};
                    self.ma.modal_action_type = flag;
                }
            });
        },

        modalHandler(){
            this.dialog_local = !this.dialog_local;
        },

        modalCloseHandler(){
            if (this.dialog_local == false){
                this.$emit('closed', false);
            }
        },

        handleValue(){
            if (this.modalInfo.Bays.length == 0){
                this.form = [ 
                    [
                    {carparkid: '', rule: [] },
                    {baynameid: '', rule: [] },
                    {baytype: '', rule: [] },
                    {baylatitude: '', rule: [] },
                    {baylongitude: '', rule: [] },
                    {bayid: ''}
                    ]
                ];
                this.total = 1;
                this.extractedNumFromString = 1;
                this.selectIteratingName = false;
            }

            else{
                this.form = [];
                for(let i=0; i<this.modalInfo.Bays.length; i++){
                    this.form.push([
                        {carparkid: '', rule: []},
                        {baynameid: this.modalInfo.Bays[i].BayNameID, rule: []},
                        {baytype: this.modalInfo.Bays[i].BayType, rule: []},
                        {baylatitude: this.modalInfo.Bays[i].BayLatitude, rule: []},
                        {baylongitude: this.modalInfo.Bays[i].BayLongitude, rule: []},
                        {bayid: this.modalInfo.Bays[i].BayID}
                    ]);
                }
                this.total = this.modalInfo.Bays.length;
                this.extractedNumFromString = 1;
                this.selectIteratingName = false;
            }
            //this.form[0].systemid = '';
            //this.form[1].systemname = '';
        },

        //set the action to be sent to watcher to execute the create/edit function
        onConfirm(value){
          //console.log(value);
                if (this.ma.modal_action_type == 'create'){
                    if (this.modalInfo.Bays.length > 0){
                        this.form.flag = 'editbay';
                        let newArr = [];
                        let oldArr = [];

                        for(let [index, item] of this.form.entries()){
                            if (item[5].bayid == ''){ //for new rows
                                newArr.push([
                                    {carparkid: ''},
                                    {baynameid: item[1].baynameid},
                                    {baytype: item[2].baytype},
                                    {baylatitude: item[3].baylatitude},
                                    {baylongitude: item[4].baylongitude},
                                    {bayid: ''}
                                ]);
                            }

                            if (item[5].bayid != ''){ //for old rows
                                oldArr.push([
                                    {carparkid: ''},
                                    {baynameid: item[1].baynameid},
                                    {baytype: item[2].baytype},
                                    {baylatitude: item[3].baylatitude},
                                    {baylongitude: item[4].baylongitude},
                                    {bayid: this.modalInfo.Bays[index].BayID}
                                ]);
                            }
                        }

                        this.form.newArr = newArr;
                        this.form.oldArr = oldArr;

                        //this.form.newrows = newArr.splice(0, 5);
                        //this.form.oldrows = newArr.slice(0, 5);
                        this.$emit('confirm', this.form);
                    }

                    else{
                        this.form.flag = 'addbay';
                        this.$emit('confirm', this.form);
                    }
                }

                this.innerModal = false;
        },

        onClosed(value){
            if (value == false){
                this.innerModal = value;
            }
        },
    }
}
</script>